module.exports = __webpack_public_path__ + "static/media/PTS-logo-white.acde7018.png";